import { put, takeLatest } from "redux-saga/effects";
import {
  requestmanageUserList,
  requestCreateUser,
  requestUpdateUser,
  requestDeleteUser,
  requestUpdateUserDetails,
  requestUserDataById,
  fetchUsersByRole,
} from "../../../services/manageUser";
import {
  fetchmanageUserRequest,
  fetchmanageUserSuccess,
  fetchmanageUserFailure,
  createmanageUserRequest,
  createmanageUserSuccess,
  createmanageUserFailure,
  updatemanageUserRequest,
  updatemanageUserSuccess,
  updatemanageUserFaliure,
  deletemanageUserRequest,
  deletemanageUserSuccess,
  deletemanageUserFaliure,
  updatemanageUserDetailsRequest,
  updatemanageUserDetailsSuccess,
  updatemanageUserDetailsFaliure,
  getUserDetailsRequest,
  getUserDetailsSuccess,
  getUserDetailsFaliure,
  fetchUsersByRoleRequest,
  fetchUsersByRoleSuccess,
  fetchUsersByRoleFailure,
} from "../../reducers/manageUsers";

export function* watchmanageUserSaga() {
  yield takeLatest(fetchmanageUserRequest, fetchmanageUserList);
  yield takeLatest(createmanageUserRequest, createManageUser);
  yield takeLatest(updatemanageUserRequest, updateUser);
  yield takeLatest(deletemanageUserRequest, deleteUser);
  yield takeLatest(updatemanageUserDetailsRequest, updateUserDetails);
  yield takeLatest(getUserDetailsRequest, getUserData);
  yield takeLatest(fetchUsersByRoleRequest, getUsersDataByRole);
}

function* fetchmanageUserList({ payload }) {
  try {
    const response = yield requestmanageUserList(payload);
    yield put(fetchmanageUserSuccess(response));
  } catch (error) {
    yield put(fetchmanageUserFailure("Failed to get list of users"));
  }
}
function* createManageUser({ payload }) {
  try {
    //service add
    const response = yield requestCreateUser(payload);
    yield put(createmanageUserSuccess(response.data));
  } catch (error) {
    yield put(createmanageUserFailure("Failed to create User"));
  }
}
function* updateUser({ payload }) {
  try {
    //service add
    const response = yield requestUpdateUser(payload);
    yield put(updatemanageUserSuccess(response.data));
  } catch (error) {
    yield put(updatemanageUserFaliure("Failed to update User"));
  }
}
function* deleteUser({ payload }) {
  try {
    const response = yield requestDeleteUser(payload);
    yield put(deletemanageUserSuccess(response));
  } catch (error) {
    yield put(deletemanageUserFaliure("Failed to Delete users"));
  }
}
function* updateUserDetails({ payload }) {
  try {
    const response = yield requestUpdateUserDetails(payload);
    yield put(updatemanageUserDetailsSuccess(response));
  } catch (error) {
    yield put(updatemanageUserDetailsFaliure(error.response.data.message|| "Unknown Error"));
  }
}
function* getUserData({ payload }) {
  try {
    const response = yield requestUserDataById(payload);
    yield put(getUserDetailsSuccess(response));
  } catch (error) {
    yield put(getUserDetailsFaliure("Failed to get users"));
  }
}

function* getUsersDataByRole({ payload }) {
  try {
    const response = yield fetchUsersByRole(payload);
    yield put(fetchUsersByRoleSuccess(response));
  } catch (error) {
    yield put(fetchUsersByRoleFailure("Failed to fetch users by role"));
  }
}
